"use strict";

angular.module("models").service("TelematicsService", ["ApiService", function (ApiService) {
  var that = this;

  angular.extend(that, ApiService.getModel("telematics", ["score"], function (element) {
    return element.score ? element.score : "???";
  }));
}]);